import React from 'react';

const GRADE_PATTERN = /^(?:100(?:\.0{1,2})?|(?:[0-9]|[1-9][0-9])(?:\.\d{1,2})?)$/;

const studentLabel = (student) =>
  student?.matricula_alumno
    ? `${student.nombre_alumno} (${student.matricula_alumno})`
    : student?.nombre_alumno || '';

export const isValidCertificateGrade = (value) => {
  const text = String(value ?? '').trim();
  return GRADE_PATTERN.test(text) && Number(text) >= 0 && Number(text) <= 100;
};

export const haveCompleteCertificateGrades = (students = [], grades = {}) =>
  students.length > 0 &&
  students.every((student) =>
    isValidCertificateGrade(grades[String(student.id_alumno)]),
  );

export const CertificateGradesStep = ({
  students = [],
  grades = {},
  onChange,
  canPreview = false,
}) => (
  <section
    className="certificate-wizard-card certificate-grades-step"
    aria-labelledby="certificate-grades-step-title"
  >
    <div className="certificate-wizard-card-heading">
      <span aria-hidden="true">3</span>
      <div>
        <h2 id="certificate-grades-step-title">Calificaciones</h2>
        <p>Captura una calificación de 0 a 100 para cada destinatario.</p>
      </div>
    </div>

    {students.length === 0 ? (
      <p className="certificate-wizard-note">
        Selecciona los destinatarios para capturar sus calificaciones.
      </p>
    ) : (
      <div className="certificate-grades-table-wrapper">
        <table className="certificate-grades-table">
          <thead>
            <tr>
              <th scope="col">Alumno</th>
              <th scope="col">Matrícula</th>
              <th scope="col">Calificación</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student) => {
              const idStudent = String(student.id_alumno);
              const label = studentLabel(student);
              return (
                <tr key={idStudent}>
                  <td>{student.nombre_alumno}</td>
                  <td>{student.matricula_alumno || '—'}</td>
                  <td>
                    <input
                      aria-label={`Calificación de ${label}`}
                      type="number"
                      min="0"
                      max="100"
                      step="0.01"
                      inputMode="decimal"
                      value={grades[idStudent] ?? ''}
                      onChange={(event) =>
                        onChange(idStudent, event.target.value)
                      }
                      required
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )}

    <div className="certificate-wizard-actions">
      <button type="submit" disabled={!canPreview}>
        Continuar a revisión
      </button>
    </div>
  </section>
);
